module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0NTAiIGhlaWdodD0iMzAwIiB2aWV3Qm94PSIwIDAgMyAyIj48cGF0aCBmaWxsPSIjRkZGIiBkPSJNMCAwaDN2MkgweiIvPjxwYXRoIGZpbGw9IiNGMDAiIGQ9Ik0wIDBoM3YxSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/idn.svg
// module id = GtPM
// module chunks = 0